import { SortDropdown } from "./SortDropdown";
import { FilterDropdown } from "./FilterDropdown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundsFilter() {
  return /*#__PURE__*/_jsxs("div", {
    className: "md:flex gap-4 font-mono text-sm",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/*#__PURE__*/_jsx("div", {
        children: "Sort by"
      }), /*#__PURE__*/_jsx(SortDropdown, {})]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/*#__PURE__*/_jsx("div", {
        children: "Filter by"
      }), /*#__PURE__*/_jsx(FilterDropdown, {})]
    })]
  });
}
export const toQueryString = function () {
  let filterParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new URLSearchParams(filterParams).toString();
};